<script>
	import { LeafletMapSrsUtil } from "@/api/geoserver/owsFeatureSearch";
	import { mapActions } from 'vuex';	
	import turf from 'turf';
	
	export default {
		name: 'LeafletMapFeatureUnderCursorSearch',
		props: {
			map: {
				type: Object,
				required: true
			},
            maskGeometryJson:{
				type: Object
            }
		},
		methods: {
			...mapActions([
				'searchByPointAsync'			
			]),
		},
		mounted() {
			const onMapClick = async function onMapClick(leafletClickEventArgs) {
				if(this.maskGeometryJson){
					if(turf.intersect(this.maskGeometryJson, {"type": "Point","coordinates": [leafletClickEventArgs.latlng.lng, leafletClickEventArgs.latlng.lat]}) == null)
						return;
                }
				
				const point = LeafletMapSrsUtil.fromLatLngToMapSrsPoint(leafletClickEventArgs.latlng, this.map);				
				const location = {
					point,
					latLng: {
						lat: leafletClickEventArgs.latlng.lat,
						lng: leafletClickEventArgs.latlng.lng
					}
				};				
				await this.searchByPointAsync(location);
			};

			//подписываемся на клик в карте чтобы делать запросы на сервер
			this.map.on('click', onMapClick, this);
			this.$once('hook:beforeDestroy', () => {
				//отписываемся от события при уничтожении компонента
				this.map.off('click', onMapClick, this);
			});
		},
		render() {
			return this.$slots.default;
		}
	}
</script>
